import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageComponent } from 'common-ui';
import { ItemStockButtonComponent } from '../../../../../item';
import { ItemPriceComponent } from '../../../../../item/common/price/item-price';
import { ProductIdLabelComponent } from '../../../../common/basic-properties/product-id-label';
import { ProductIsCanadianComponent } from '../../../../common/basic-properties/product-is-canadian';
import { ProductShortDescriptionComponent } from '../../../../common/basic-properties/product-short-description';
import { RenderInProductResultLayoutDirective } from '../../../../layouts/product-result/product-result-layout/render-targets/render-in-product-result-layout.directive';
import { ProductResultLayoutComponentsProviderComponentBase } from '../../../../layouts/product-result/ProductResultLayoutComponentsProviderComponentBase';

@Component({
  selector: 'ideal-wire-cut-product-result-layout-components-provider',
  imports: [
    RenderInProductResultLayoutDirective,
    ImageComponent,
    ProductIdLabelComponent,
    ProductShortDescriptionComponent,
    ProductIsCanadianComponent,
    ItemPriceComponent,
    ItemStockButtonComponent,
  ],
  standalone: true,
  templateUrl: './wire-cut-product-result-layout-components-provider.component.html',
  styleUrls: [
    '../../../../../product/layouts/product-result/product-result-base.scss',
    './wire-cut-product-result-layout-components-provider.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WireCutProductResultLayoutComponentsProviderComponent extends ProductResultLayoutComponentsProviderComponentBase {}
